export default {
  INFO_DASHBOARD: "/info-list",
  LEAD_GENERATOR_DASHBOARD: "/lead-generator",
  LEAD_DASHBOARD: "/lead",
  VENDOR_DASHBOARD: "/vendor",
  CLINIC_DASHBOARD: "/clinic",
  DRIVER_DASHBOARD: "/driver",
  REGISTER_VENDOR: "/register-vendor",
  HEALTH_PLANS: "/health-plans",
  ASSIGN_TO_CLOSER: "/assign-to-closer",
  ASSIGNED_CLOSER: "/assigned-closer",
  WAIT_LIST: "/wait-list",
  ASSIGN_TO_VENDOR: "/assign-to-vendor",
  ASSIGNED_VENDOR: "/assigned-vendor",
  SERVICE_PENDING: "/service-pending",
};



// WEBPACK FOOTER //
// ./client/constants/routes.js